import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config";
import Modal from "../components/Modal";
import AlertModal from "../components/AlertModal";
import "../styles/LoginPage.css";
import logo from "../assets/images/logo.ico";
import { useUser } from "../context/UserContext"; // 추가


const LoginPage = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isRegisterOpen, setRegisterOpen] = useState(false);
  const [nickname, setNickname] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [nicknameAvailable, setNicknameAvailable] = useState(false);
  const [userIdAvailable, setUserIdAvailable] = useState(false);

  const { setUserInfo } = useUser(); // 상단에 선언
 
  // ✅ 로그인 상태 확인 후 자동 이동
  

  useEffect(() => {
    if (isRegisterOpen) {
      setNickname("");
      setUserId("");
      setPassword("");
      setConfirmPassword("");
    }


  }, [isRegisterOpen]);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (isLoggedIn) {
    navigate("/"); // 이미 로그인 되어 있으면 메인으로 이동
    }
  }, [navigate]);

   // 닉네임 중복 확인
   const checkDuplicateNickname = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/check-nickname?nickname=${nickname}`,{
        headers: {
             'X-Frontend-Request': 'true',
          },
      });
      if (!response.ok) {
        throw new Error("서버 오류");
      }
      const isUnique = await response.json();
    
      if (!isUnique) {
         showAlert("사용 가능한 닉네임입니다.");
        setNicknameAvailable(true);
      } else {
         showAlert("이미 사용 중인 닉네임입니다.");
        setNicknameAvailable(false);
      }
    } catch (error) {
      console.error("닉네임 중복 확인 오류:", error);
       showAlert("중복 확인 중 오류가 발생했습니다.");
    }
  };

  // 아이디 중복 확인
  const checkDuplicateUserId = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/check-username?username=${userId}`,{ headers: {
             'X-Frontend-Request': 'true',
          },});
      if (!response.ok) {
        throw new Error("서버 오류");
      }
      const isUnique = await response.json();
    
      if (!isUnique) {
        
         showAlert("사용 가능한 아이디입니다.");
        setUserIdAvailable(true);
      } else {
         showAlert("이미 사용 중인 아이디입니다.");
        setUserIdAvailable(false);
      }
    } catch (error) {
      console.error("아이디 중복 확인 오류:", error);
       showAlert("중복 확인 중 오류가 발생했습니다.");
    }
  };

  
  // 회원가입 API 호출
  const handleRegister = async () => {
 
    if (!userId.trim() || !nickname.trim() || !password.trim()) {
       showAlert("아이디, 닉네임, 비밀번호를 모두 입력해주세요.");
      return;
    }
  
    if (password !== confirmPassword) {
       showAlert("비밀번호가 일치하지 않습니다.");
      return;
    }

    if (!nicknameAvailable || !userIdAvailable) {
       showAlert("닉네임 또는 아이디 중복 확인을 완료해 주세요.");
      return;
    }
    const registerData = {
      username: userId,
      nickname: nickname,
      password: password,
      adminType: "대리점",
    };
  
    try {
      const response = await fetch(`${API_BASE_URL}/admin/register`, {
        method: "POST",
        headers: {
              'X-Frontend-Request': 'true',
          "Content-Type": "application/json",
        },
        body: JSON.stringify(registerData),
      });
  
      if (!response.ok) {
        throw new Error("회원가입 실패");
      }
  
      const data = await response.json();
     
      // ✅ 회원가입 성공 후 자동 로그인 처리
      await doLogin({ username: userId, password });
  
      setRegisterOpen(false);
    } catch (error) {
      console.error("회원가입 오류:", error);
       showAlert("회원가입 중 오류가 발생했습니다.");
    }
  };

  const showAlert = (message) => {
    setAlertMessage(message);
    setIsAlertOpen(true);
  };
// 1. 공통 로그인 처리 함수
const doLogin = async (loginData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/login`, {
      method: "POST",
       headers: {
              'X-Frontend-Request': 'true',
          "Content-Type": "application/json",
        },
      body: JSON.stringify(loginData),
    });

    if (response.ok) {
      const user = await response.json();
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("userName", user.username);
      localStorage.setItem("userType", user.adminType);
      localStorage.setItem("egg", user.egg);
      setUserInfo(user);

      navigate("/"); // 홈으로 이동
    } else {
      const errorMessage = await response.text();
      showAlert(errorMessage);
    }
  } catch (error) {
    console.error("로그인 오류:", error);
    showAlert("로그인 중 오류가 발생했습니다.");
  }
};

// 2. 로그인 버튼에서 호출
const handleLogin = (e) => {
  e.preventDefault();
  if (!userId || !password) {
    showAlert("아이디와 비밀번호를 입력해주세요.");
    return;
  }
  doLogin({ username: userId, password });
};

  return (
    <div className="login-page">
      <form className="form-area" onSubmit={handleLogin}>
      <div className="form-title">
      <img
      src={logo}
      alt="사이트 로고"
      className="site-logo"
    />
   
    <span className="site-name">Holdem 3</span>
    </div>
        <div className="form-item">
          <label>아이디</label>
          <input
            type="text"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            autoComplete="username"
          />
        </div>
        <div className="form-item">
          <label>비밀번호</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="off"
            name="pwd"
          />
        </div>
        <button type="submit" className="btn-primary btn-login">
          로그인
          <img src="/static/media/btn_login.531b05b0b95e1d72f3fa9d9815a3ea93.svg" alt="로그인하기" />
        </button>

        <button type="button" className="btn-register btn-black" onClick={() => setRegisterOpen(true)}>
          회원가입
          <img alt="회원가입하기" src="/static/media/btn_register.542164fd7a44a3880f8fa7eed39d9987.svg"></img>
        </button>
      </form>

      {isAlertOpen && <AlertModal message={alertMessage} onClose={() => setIsAlertOpen(false)} />}
        
        {/* 회원가입 모달 */}
        <Modal id="modalRegister" isOpen={isRegisterOpen} closeModal={() => setRegisterOpen(false)}>
          <form className="form-area">
            <div className="form-item">
              <label>닉네임</label>
              <div className="input-group">
                <input
                  type="text"
                  value={nickname}
                  onChange={(e) => {setNickname(e.target.value);setNicknameAvailable(false);}} // nickname 상태 설정
                />
                 <button type="button" className="btn-check" onClick={checkDuplicateNickname}>중복 확인</button>
              </div>
            </div>
          
            <div className="form-item">
              <label>아이디</label>
              <div className="input-group">
                <input
                  type="text"
                  value={userId}
                  onChange={(e) => {setUserId(e.target.value);setUserIdAvailable(false);}} // userId 상태 설정
                />
                  <button type="button" className="btn-check" onClick={checkDuplicateUserId}>중복 확인</button>
              </div>
            </div>

            <div className="form-item">
              <label>비밀번호</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)} // password 상태 설정
             
              />
            </div>

            <div className="form-item">
              <label>비밀번호 확인</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)} // confirmPassword 상태 설정
              />
            </div>

            <button type="button"
              className="btn-primary"
              onClick={handleRegister} // 회원가입 로직 추가
              style={{ backgroundColor: "#2ecc71" }}
            >
              회원가입
            </button>
            <button type="button" className="btn-primary-outline" onClick={() => setRegisterOpen(false)}>닫기</button>
          </form>
        </Modal>
    </div>

    
  );
};

export default LoginPage;